import { render, staticRenderFns } from "./InformalSector.vue?vue&type=template&id=06ef79cd&scoped=true&"
import script from "./InformalSector.vue?vue&type=script&lang=js&"
export * from "./InformalSector.vue?vue&type=script&lang=js&"
import style0 from "./InformalSector.vue?vue&type=style&index=0&id=06ef79cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef79cd",
  null
  
)

export default component.exports